import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'

export default {
    install: (app) => {
        app.provide('CookieConsent', CookieConsent)
    }
}
